import { handleFormButtonAnimationPollyfills } from './formSubmissionAnimation'
import { addOverlayDivToElem, createOverlayDiv } from './helpers'

export default (
    { formSelector, buttonId, transitionDurationInSec, preserveWidth = false },
    svgSpinnerOpts = {}
  ) =>
  () => {
    let formSubmitting = false

    const form = formSelector ? document.querySelector(formSelector) : null
    const button = document.getElementById(buttonId)
    const loadingOverlay = createOverlayDiv()

    if (!form && !button) {
      return
    }
    if (button) {
      addOverlayDivToElem(button, loadingOverlay, transitionDurationInSec)
    }

    // If the form is not given, just use the button for applying the loading animation.
    // The current use case is in the cart, where no form element exists and the animation needs
    // to be applied to the checkout button nonetheless.
    ;(form || button).addEventListener(form ? 'submit' : 'click', function (e) {
      if (formSubmitting) {
        e.preventDefault()
        return
      }
      if (!form || form.checkValidity()) {
        formSubmitting = true
        handleFormButtonAnimationPollyfills({
          form,
          button,
          loadingOverlay,
          svgSpinnerOpts,
          preserveWidth,
          event: e,
        })
      }
    })
  }
